import { EnvironmentFilter } from '../enums';

// Order matters: this list drives the Organization Settings > Fund filters screen and
// must read in the same sequence as the filter bars it controls - the dashboard Disease
// dialog, the embed filter bar, both fund detail blocks and the PDF.
export const EnvironmentFilters = [
  { value: EnvironmentFilter.InsuranceFilter, name: 'Insurance Type' },
  { value: EnvironmentFilter.SupportFilter, name: 'Support Type' },
  { value: EnvironmentFilter.StateFilter, name: 'State' },
  { value: EnvironmentFilter.ZipcodeFilter, name: 'Zipcode' },
  { value: EnvironmentFilter.HouseholdPersonsFilter, name: 'Persons in household' },
  { value: EnvironmentFilter.HouseholdIncomeFilter, name: 'Household Income' },
  { value: EnvironmentFilter.AgeFilter, name: 'Age' },
];
